import { useReducer, useMemo } from 'react';

type Params = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeId: string;
  userId: string;
  userType?: string;
  transactionType?: string;
  fromDate?: string;
  toDate?: string;
};

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const storeId = userData?.userDetails?.storeId || undefined;
  const userId = userData?.userId || '';
  const userType = 'MERCHANT'

  return {
    sortBy: 'createdAt',
    sortOrder: 'desc',
    page: 1,
    limit: 10,
    search: undefined,
    storeId,
    userId,
    userType,
    transactionType:'all'
  };
};


type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_FILTERS'; payload: Partial<Params>; resetPage?: boolean }
  | { type: 'SET_FROM_DATE'; payload: string | undefined }
  | { type: 'SET_TO_DATE'; payload: string | undefined }
  | { type: 'SET_TRANSACTION_TYPE'; payload: string | undefined }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload};
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };
    case 'SET_FROM_DATE':
      return { ...state, fromDate: action.payload };
    case 'SET_TO_DATE':
      return { ...state, toDate: action.payload };
    case 'SET_TRANSACTION_TYPE':
      console.log('SET_TRANSACTION_TYPE dispatched:', action.payload);
      return { ...state, transactionType: action.payload };
    case 'SET_FILTERS':
      return {
        ...state,
        ...Object.fromEntries(
          Object.entries(action.payload).map(([key, val]) => [key, val === '' ? undefined : val])
        ),
      };
    case 'RESET':
      return {
        ...state,
        fromDate: undefined,
        toDate: undefined,
        search: undefined,
        transactionType: 'all',
        page: 1,
      };
    default:
      return state;
  }
}

export function useManageSettlements() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => {
    // Only include date parameters if both fromDate and toDate are present
    const { fromDate, toDate, ...otherParams } = params;
    if (fromDate && toDate) {
      return { ...otherParams, fromDate, toDate };
    }
    return otherParams;
  }, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.storeId,
    params.userId,
    params.userType,
    params.transactionType,
    params.fromDate,
    params.toDate
  ]);

  return { params: stableParams, dispatch };
}
